<template>
    <v-select :value="value" :items="rounds" label="Round" @input="val => $emit('input', val)"> </v-select>
</template>

<script>
export default {
    name: 'RoundSelector',

    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
    },

    data: () => ({
        rounds: [
            { value: 'prelims', text: 'Qualification' },
            { value: 'semi_final', text: 'Q2' },
            { value: 'finals', text: 'Finals' },
            { value: 'final_one', text: 'Final One' },
            { value: 'final_two', text: 'Final Two' },
        ],
    }),
};
</script>
